<template>
  <div class="calculate-panel">
    <div class="left">
      <div class="modal-calc">
        <el-form>
          <el-form-item class="line-height" label="函数">
            <el-cascader
              :options="optionalFuntion"
              :show-all-levels="false" :value="leftPage.value" @change="changeFunctionValue" filterable>
            </el-cascader>
            <el-button class="replace" @click="replaceFormula">替换</el-button>
            <el-button class="insert" @click="insertFormula">插入</el-button>
          </el-form-item>
          <el-form-item class="line-height form-item-formula" label="公式">
            <div class="formula" contenteditable
                 @blur="saveCursor" ref='formula'
                 v-focus v-html="htmlContent">
            </div>
          </el-form-item>
          <el-form-item label="描述">
            <div class="describe">
              {{leftPage.tip}}
            </div>
          </el-form-item>
          <el-form-item label="示列">
            <div class="examples">
              {{leftPage.example}}
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="right">
      <div v-if="dataSourceEnable">
        <el-form>
          <el-form-item label="辅助表">
            <el-select placeholder="请选择" v-model="dataSourceReport.dataSourceReportId" filterable clearable
                       @change="loadTableColumns">
              <el-option
                v-for="item in dataSourceReports"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="line-height" v-for="(filter,index) in dataSourceReport.filters" :label="filter.name"
                        :key='filter.columnId'>
            <div class="formula filter" :class="'filter_' + index" contenteditable
                 @blur="saveCursor" ref="filter"
                 :filterId="filter.id" v-html="dataSourceReport.filterHtml.find(m => m.id === filter.id)
                 && dataSourceReport.filterHtml.find(m => m.id === filter.id).html">
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="modal-columns">
        <h4>数据源</h4>
        <div class="columns">
          <el-menu class="el-menu-vertical">
            <div v-for="(table, index) in dataSource" :key="index">
              <el-submenu :index="index.toString()" v-if="table.columns">
                <span slot="title" :name="table.name">{{table.type === 'OneToMany' ? '*':''}}{{table.name}}</span>
                <el-menu-item-group>
                  <el-menu-item v-for="column in table.columns"
                                v-if="currentColumnId !== column.id"
                                :key='column.id'
                                :index="column.id"
                                :name="column.name"
                                :type="column.dataType"
                                @click='addParam(column.name,column.id,table.relationId,column.dataType,table.name)'>
                    {{column.name}}
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>

              <!--生成数据源报表信息用于点击-->
              <el-submenu v-if="dataSourceReport.dataSourceReportId" :index="dataSourceReport.dataSourceReportId">
                <span slot="title">{{getDataSourceReportName}}</span>
                <el-menu-item-group>
                  <el-menu-item v-for="column in dataSourceReport.columns"
                                :key='column.id'
                                :index='column.id'
                                :name="column.name"
                                :type="column.dataType"
                                @click='addReportParam(column.id, dataSourceReport.dataSourceReportId, column.name)'>
                    {{column.name}}
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </div>
          </el-menu>
        </div>
      </div>
    </div>
  </div>

</template>

<script type="text/babel">
import getFormula from './formula.js'

export default {
  name: 'calculation',
  props: ['parameter'],
  data () {
    return {
      options: getFormula(),
      leftPage: {
        value: [],
        tip: '',
        example: '',
        cacheformula: '',
        cacheRange: ''
      },
      expression: '',
      functionType: ['simple', 'math', 'text', 'date', 'concat'],
      calculationType: 'java',
      dataSource: [],
      currentColumnId: '',
      dataSourceEnable: false,
      dataSourceReports: [],
      dataSourceReport: {
        dataSourceReportId: '',
        filters: [],
        columns: [],
        filterHtml: []
      }
    }
  },
  created () {
    for (let prop in this.parameter) {
      if (this.parameter.hasOwnProperty(prop)) {
        this[prop] = this.parameter[prop]
      }
    }
  },
  mounted () {
    this.leftPage.tip = this.options[0].tip
    this.leftPage.example = this.options[0].example
  },
  computed: {
    htmlContent () {
      let expression = this.expression
      if (expression) {
        let htmlContent = this.expressionToWithCode(expression)
        return htmlContent
      }
    },
    optionalFuntion () {
      let options = this.options
      options.forEach(el => {
        el.disabled = !this.functionType.includes(el.value)
      })
      return options
    },
    getDataSource () {
      return this.dataSource
    },
    getDataSourceReportName () {
      let table = this.dataSourceReports.find(m => m.id === this.dataSourceReport.dataSourceReportId)
      if (table) {
        return table.name
      }
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  methods: {
    // 点击数据列
    addParam (name, id, relationId, type, tableName) {
      if (!this.leftPage.cacheRange) {
        this.$message.info('请选择插入的位置')
        return false
      }
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(this.leftPage.cacheRange)
      var html = `&nbsp;<code contenteditable='false' dataId=${id}+${relationId} name=${name} type='${type}'>${tableName}-${name}</code>&nbsp;`
      // 替换选中的内容
      document.execCommand('insertHTML', false, html)
      let className = this.leftPage.cacheRange.focusNode.className || this.leftPage.cacheRange.focusNode.parentElement.className
      if (className === 'formula') {
        this.selectParam(this.$refs.formula)
      } else if (className.includes('filter')) {
        let index = className.split(' ')[2].slice(7)
        this.selectParam(this.$refs.filter[index])
      }
    },

    // 点击报表列
    addReportParam (id, tableId, name) {
      if (!this.leftPage.cacheRange) {
        this.$message.info('请选择插入的位置')
        return false
      }
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(this.leftPage.cacheRange)
      this.selectParam(this.$refs.formula)
      var html = `&nbsp;<code contenteditable='false' dataId=${id}+${tableId} name=${this.getDataSourceReportName}-${name} type='sql'>sql(${this.getDataSourceReportName}-${name})</code>&nbsp;`
      // 替换选中的内容
      // todo: 需要增加判断用于判断当前元素插入何处
      document.execCommand('insertHTML', false, html)
    },

    replaceFormula () {
      this.$refs.formula.innerHTML = this.leftPage.cacheformula
      this.selectParam(this.$refs.formula)
    },

    insertFormula () {
      let sel = window.getSelection()
      // 判断光标是否停在公式的div中
      if (sel.anchorNode === this.leftPage.cacheRange.anchorNode) {
        // 取到选中的元素的索引
        document.execCommand('insertHTML', false, this.leftPage.cacheformula)
        this.selectParam(this.$refs.formula)
      } else {
        this.$message({
          message: '请选择插入的位置'
        })
      }
    },

    // 光标选中第一个param
    selectParam (selector) {
      selector.focus()
      let sel = window.getSelection()
      let range = sel.getRangeAt(0)
      for (let i = 0, length = selector.childNodes.length; i < length; i++) {
        if (selector.childNodes[i].nodeName === '#text') {
          let str = selector.childNodes[i].data
          let arr = str.split('param')
          let num = arr.length - 1
          if (num >= 1) {
            // 选择第一个param为光标范围
            range.setStart(selector.childNodes[i], arr[0].length)
            range.setEnd(selector.childNodes[i], arr[0].length + 5)
          }
        }
      }
    },
    // 公式div的失焦事件
    saveCursor () {
      let sel = window.getSelection()
      if (sel.rangeCount) {
        this.leftPage.cacheRange = sel.getRangeAt(0)
        this.leftPage.cacheRange.anchorNode = sel.anchorNode
        this.leftPage.cacheRange.anchorOffset = sel.anchorOffset
        this.leftPage.cacheRange.focusNode = sel.focusNode
        this.leftPage.cacheRange.focusOffset = sel.focusOffset
      }
    },
    // 选择改变下拉框的
    changeFunctionValue (val) {
      if (val[1]) {
        // 如函数有第二级
        let item = this.options.find(o => o.value === val[0]).children.find(m => m.value === val[1])
        this.leftPage.cacheformula = item.value
        this.leftPage.tip = item.tip
        this.leftPage.example = item.example
      } else {
        this.leftPage.cacheformula = ''
        this.leftPage.tip = this.options[0].tip
        this.leftPage.example = this.options[0].example
      }
    },
    closePanel () {
      this.$emit('close')
      this.$refs.formula.innerHTML = ''
    },

    getValue () {
      let formula = this.$refs.formula.innerHTML
      let handleFormula = this.getExpression(formula)
      let filters = this.$refs.filter
      if (filters) {
        let parameters = []
        filters.forEach(m => {
          let filterFormula = this.getExpression(m.innerHTML)
          if (filterFormula) {
            parameters.push(`parameter['${m.getAttribute('filterId')}', ${filterFormula}]`)
          }
        })
        handleFormula = this.handlerFilter(handleFormula, parameters.join(', '))
      }
      return handleFormula
    },

    handlerFilter (handleFormula, parameter) {
      handleFormula.match(/sql(.+?)\)/g) && handleFormula.match(/sql(.+?)\)/g).forEach(m => {
        let sqlStr = m.slice(0, m.indexOf(')')) + ',' + parameter + m.slice(m.indexOf(')'), m.length)
        handleFormula = handleFormula.replace(m, sqlStr)
      })
      return handleFormula
    },

    getExpression (formula) {
      if (formula === '') {
        return formula
      }
      formula = formula.replace(/&gt;/g, '>')
      formula = formula.replace(/&lt;/g, '<')
      formula.match(/<code(.+?)<\/code>/g) && formula.match(/<code(.+?)<\/code>/g).map((el) => {
        let dataId = el.match(/dataid="(.+?)"/g).toString()
        let type = el.match(/type="(.+?)"/g).toString()
        let name = el.match(/name="(.+?)"/g).toString()
        let newstr = ''
        if (type.includes('sql')) {
          newstr = `sql($\{${dataId.slice(8, dataId.length - 1)},${name.slice(6, name.length - 1)},${type.slice(6, type.length - 1)}})`
        } else {
          newstr = `$\{${dataId.slice(8, dataId.length - 1)},${name.slice(6, name.length - 1)},${type.slice(6, type.length - 1)}}`
        }
        el.replace(el, newstr)
        formula = formula.replace(el, newstr)
      })
      let handleFormula = formula.replace(/&nbsp;/g, '')
      return handleFormula
    },

    validate () {
      let expression = this.getValue()
      return new Promise((resolve, reject) => {
        let cancatFuns = []
        // todo: 获取聚合函数的方式需要修改
        // 获取所有的聚合函数
        this.options.find(m => m.value === 'concat').children.forEach(m => {
          cancatFuns.push(m.value.substring(0, m.value.indexOf('(')))
        })
        expression = expression.replace(/\s/g, '')
        let regs = new RegExp(`(${cancatFuns.join('|')})\\((.+?)\\)`, 'gi')
        let oneToMaycolumns = []
        expression.match(regs) && expression.match(regs).map(m => {
          if (!m.match(/sql\((.+?)\)/g)) {
            if (m.match(/\$\{(.*?)\}/)) {
              m.match(/\$\{(.*?)\}/g).forEach(n => {
                oneToMaycolumns.push({
                  'functionName': m.substring(0, m.indexOf('(')),
                  'columnId': n.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[0],
                  'relationId': n.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[1]
                })
              })
            }
          }
        })
        let oneToOneColumns = []
        expression.match(/\$\{(.*?)\}/g) && expression.match(/\$\{(.*?)\}/g).map(m => {
          let columnId = m.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[0]
          let relationId = m.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[1]
          let type = m.match(/\$\{(.*?)\}/)[1].split(',')[2] && m.match(/\$\{(.*?)\}/)[1].split(',')[2]
          if (type !== 'sql') {
            let temp = oneToMaycolumns.find(n => n.columnId === columnId && n.relationId === relationId)
            if (!temp) {
              oneToOneColumns.push({
                columnId,
                relationId
              })
            }
          }
        })
        if (this.calculationType.toLocaleLowerCase() === 'java') {
          for (let i = 0; i < oneToOneColumns.length; i++) {
            let table = this.getTableByColumnId(oneToOneColumns[i])
            if (table.type !== 'OneToOne') {
              let column = table.columns.find(m => m.id === oneToOneColumns[i].columnId)
              reject(new Error(`参数 ${column.name} 需要配合聚合函数使用`))
              break
            }
          }
          for (let i = 0; i < oneToMaycolumns.length; i++) {
            let table = this.getTableByColumnId(oneToMaycolumns[i])
            if (table && table.type !== 'OneToMany') {
              reject(new Error(`函数 ${oneToMaycolumns[i].functionName} 需要选择子表信息(带有 * 号的为子表)`))
              break
            }
          }
        }
        this.$axios.post(`/report-api/report/calculation/verification`, {formula: expression}).then(() => {
          resolve()
        })
        // resolve()
      })
    },

    getTableByColumnId (column) {
      return this.dataSource.find(m => {
        if (m.columns && m.columns.find(n => n.id === column.columnId)) {
          return m
        }
      })
    },

    expressionToWithCode (expression) {
      expression = this.handleSqlExpression(expression)
      expression.match(/\$\{(.+?)\}/g) && expression.match(/\$\{(.+?)\}/g).map((el) => {
        let dataId = el.replace(/[${}]/g, '').split(',')[0].split('+')[0]
        let relationId = el.replace(/[${}]/g, '').split(',')[0].split('+')[1]
        let codeAttr = this.find(this.getDataSource, dataId, relationId)
        let code = `&nbsp;<code contenteditable='false' dataId=${codeAttr.column.id}+${codeAttr.relationId} name=${codeAttr.column.name} type='${codeAttr.column.dataType}'>${codeAttr.tableName}-${codeAttr.column.name}</code>&nbsp;`
        expression = expression.replace(el, code)
      })
      return expression
    },

    // 处理辅助表表达式
    handleSqlExpression (expression) {
      if (expression.match(/sql\((.+?)\)/g)) {
        // 筛选条件
        expression.match(/parameter\[(.+?)\]/g) && expression.match(/parameter\[(.+?)\]/g).map(m => {
          expression = expression.replace(m, '')
          // 这种写法极易出问题, 格式不严格会出问题
          let filterId = m.slice(11, 47)
          let filterExpress = this.expressionToWithCode(m.slice(50, m.length - 1).trim())
          this.dataSourceReport.filterHtml.push({'id': filterId, 'html': filterExpress})
        })
        let tableId = ''
        expression.match(/sql\((.+?)\)/g) && expression.match(/sql\((.+?)\)/g).map(m => {
          if (m.match(/\$\{(.*?)\}/g)) {
            let id = m.match(/\$\{(.*?)\}/g)[0].replace(/[${}]/g, '').split(',')[0].split('+')[0]
            tableId = m.match(/\$\{(.*?)\}/g)[0].replace(/[${}]/g, '').split(',')[0].split('+')[1]
            let name = m.match(/\$\{(.*?)\}/g)[0].match(/\$\{(.*?)\}/)[1].split(',')[1] && m.match(/\$\{(.*?)\}/)[1].split(',')[1]
            let code = `&nbsp;<code contenteditable='false' dataId=${id}+${tableId} name=${name} type='sql'>sql(${name})</code>&nbsp;`
            expression = expression.replace(m, code)
          }
        })
        this.dataSourceReport.dataSourceReportId = tableId
        this.loadTableColumns(tableId)
      }
      return expression
    },

    // 加载公式的时候dataId去数据列中遍历右侧的数据列找到对应列的name,id,tyle,和表名
    find (tables, id, relationId) {
      let column = {}
      let table
      if (relationId === 'undefined') {
        table = tables.find(m => {
          column = m.columns.find(n => n.id === id)
          if (column) {
            relationId = m.relationId
            return m
          }
        })
      } else {
        table = tables.find(m => m.relationId === relationId)
        column = table.columns && table.columns.find(m => m.id === id)
      }
      return {column, 'tableName': table.name, relationId}
    },
    loadTableColumns (val) {
      this.dataSourceReport.filters = []
      this.dataSourceReport.columns = []
      if (val) {
        this.$axios.get(`/report-api/report/definition/${val}?type=run`)
          .then(res => {
            let report = res.data
            report.filters.forEach(m => {
              let column = report.columns.find(n => n.id === m.columnId)
              if (column) {
                m.name = column.name
              }
              this.dataSourceReport.filters.push(this.$_.pick(m, ['id', 'columnId', 'defaultValue', 'name']))
            })
            report.columns.forEach(m => {
              this.dataSourceReport.columns.push({'id': m.id, 'name': m.name, 'dataType': m.columnType})
            })
          })
      }
      this.removeSql()
    },
    removeSql () {
      let formula = this.$refs.formula === undefined ? '' : this.$refs.formula.innerHTML
      formula.match(/<code(.+?)<\/code>/g) && formula.match(/<code(.+?)<\/code>/g).map((el) => {
        let type = el.match(/type="(.+?)"/g).toString()
        if (type === 'sql') {
          formula = formula.replace(el, '')
        }
      })
    }
  }
}

</script>

<style lang="scss">
  .calculate-panel {
    overflow: hidden;
    .left {
      width: 500px;
      height: 100%;
      float: left;
      margin-left: 70px;
      form {
        > .line-height {
          margin-bottom: 22px;
          height: 28px;
          .el-form-item__content {
            height: 28px;
            line-height: 28px;
          }
        }
        .form-item-formula {
          .el-form-item__content {
            line-height: 26px;
          }
        }
        .el-form-item__content {
          margin-left: 44px;
        }
        button.el-button {
          width: 55px;
          height: 28px;
          padding-top: 5px;
        }
        .insert {
          margin-left: -5px;
        }
        .describe {
          width: 456px;
          height: 141px;
          border: 1px solid #e4e7ed;
          border-radius: 4px;
        }
        .examples {
          width: 456px;
          height: 92px;
          border: 1px solid #e4e7ed;
          border-radius: 4px;
        }
      }
    }
    .right {
      width: 290px;
      height: 100%;
      float: right;
      margin-right: 70px;
    }
    .formula {
      outline: none;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      padding: 0 10px;
      height: 29px;
      overflow: auto;

      code {
        padding: 2px 4px;
        font-size: 90%;
        color: #c7254e;
        background-color: #f9f2f4;
        border-radius: 4px;
      }
    }
  }

  .modal-calc {
    .el-cascader {
      width: 342px;
      line-height: 28px;
      .el-input__inner {
        height: 28px;
        line-height: 28px;
      }
    }
    .info {
      color: rgb(49, 112, 143);
      background-color: rgb(217, 237, 247);
      border: 1px solid rgb(188, 232, 241);
      padding: 15px;
      border-radius: 4px;
      height: 134px;
      overflow: auto;
    }
    .example {
      // 允许文字被鼠标选中
      -moz-user-select: text;
      -o-user-select: text;
      -webkit-user-select: text;
      -ms-user-select: text;
      user-select: text;
    }
  }

  .modal-columns {
    h4 {
      font-size: 14px;
    }
    .columns {
      border: 1px solid #ddd;
      border-radius: 6px;
      overflow-y: auto;
      max-height: 334px;
      min-height: 334px;
      .el-menu-item-group__title {
        padding: 0;
      }
      .el-menu > div {
        border-bottom: 1px solid #ddd;
        .el-submenu__title {
          width: 100%;
          height: 34px;
          line-height: 34px;
          color: #62b2f3;
          i {
            color: #62b2f3;
          }
        }
        .el-menu-item:hover {
          outline: 0;
          background-color: #b7e0ff;
        }
        .el-menu-item {
          width: 100%;
          height: 24px;
          line-height: 24px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/globalComponent/calculation/calculation.vue